/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberExitController', MemberExitController);

    MemberExitController.$inject = ['$scope', '$state', '$stateParams', '$http'];

    function MemberExitController($scope, $state, $stateParams, $http) {
        var vm = this;

        vm.guestExitYear = new Date().getFullYear() - 3;
        vm.mode = $stateParams.mode;
        vm.members = [];
        vm.membersValid = 0;
        vm.membersInvalid = 0;
        vm.membersSelectedCount = 0;
        vm.processCurrentSelection = processCurrentSelection;
        vm.canProcess = canProcess;
        vm.updateProcessCount = updateProcessCount;

        loadAll();

        function loadAll() {
            $http.get('api/board/profiles/exit', {
                params: {
                    mode: vm.mode
                }
            }).then(function(response) {
                vm.members = response.data;
                for(var index = 0; index < vm.members.length; index++) {
                    vm.members[index].processMember = vm.members[index].criteria.summary;
                    if (vm.members[index].processMember) {
                        vm.membersSelectedCount++;
                    }
                }
                vm.membersValid = vm.membersSelectedCount;
                vm.membersInvalid = vm.members.length -  vm.membersValid;
            });
        }

        function processCurrentSelection() {
            var members = [];
            for(var index = 0; index < vm.members.length; index++) {
                if (vm.members[index].processMember) {
                    members.push(vm.members[index].id);
                }
            }
            $state.transitionTo('member-management.exit.process', {
                mode: vm.mode,
                members: members.join(",")
            });
        }

        function canProcess() {
            return vm.membersSelectedCount > 0;
        }

        function updateProcessCount(value) {
            if (value) {
                vm.membersSelectedCount++;
            } else {
                vm.membersSelectedCount--;
            }
        }
    }
})();
